import * as React from "react";
import Button from "@mui/material/Button";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import Dialog from "@mui/material/Dialog";
import DialogContentText from "@mui/material/DialogContentText";

export default function OTPVerificationAlertBox(props) {
  const { setOpen, open, resetForm } = props;

  const handleClose = () => {
    setOpen(false);
    resetForm();
  };
  return (
    <Dialog
      sx={{ "& .MuiDialog-paper": { width: "80%", maxHeight: 435 } }}
      maxWidth="sm"
      // TransitionProps={{ onEntering: handleEntering }}
      open={open}
    >
      <DialogTitle>Registration Info</DialogTitle>
      <DialogContent dividers>
        <DialogContentText>
          OTP Try Exhausted
          <br />
          Please Start registration from first step
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose}>OK</Button>
      </DialogActions>
    </Dialog>
  );
}
